import { render } from "./SendToDataSheet.vue?vue&type=template&id=5015a7b9&scoped=true"
import script from "./SendToDataSheet.vue?vue&type=script&lang=js"
export * from "./SendToDataSheet.vue?vue&type=script&lang=js"

import "./SendToDataSheet.vue?vue&type=style&index=0&id=5015a7b9&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5015a7b9"]])

export default __exports__